import { all, fork } from 'redux-saga/effects';
import authSagas from './auth';

export const rootSaga = function* root() {
  yield all([fork(authSagas)]);
};
